var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrThreeDot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 4,
    viewBox: "0 0 19 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.125 2C0.125 0.896 1.05833 0 2.20833 0C3.35833 0 4.29167 0.896 4.29167 2C4.29167 3.104 3.35833 4 2.20833 4C1.05833 4 0.125 3.104 0.125 2ZM9.5 0C8.35 0 7.41667 0.896 7.41667 2C7.41667 3.104 8.35 4 9.5 4C10.65 4 11.5833 3.104 11.5833 2C11.5833 0.896 10.65 0 9.5 0ZM16.7917 0C15.6417 0 14.7083 0.896 14.7083 2C14.7083 3.104 15.6417 4 16.7917 4C17.9417 4 18.875 3.104 18.875 2C18.875 0.896 17.9417 0 16.7917 0Z",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrThreeDot);
export default __webpack_public_path__ + "static/media/hr_three_dot.32ecbdba9144798833e647cf7dd76d70.svg";
export { ForwardRef as ReactComponent };